export default __webpack_public_path__ + "static/media/FB-Meta.664d5bed.svg";